const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\KOMMUTER\\ride-sharing-app\\app\\js\\ride-sharing-admin\\components\\AdminUsersRoute.tsx";import { useParams } from "@opendash/router";
import Parse from "parse";
import React from "react";
import { AdminUsersList } from "./AdminUsersList";

const unverifiedQuery = new Parse.Query(Parse.User)
  .equalTo("tenantVerified", false)
  .notEqualTo("tenantBanned", true)
  .notEqualTo("tenantAdmin", true)
  .include("rsProfile");

const verifiedQuery = new Parse.Query(Parse.User)
  .equalTo("tenantVerified", true)
  .notEqualTo("tenantBanned", true)
  .notEqualTo("tenantAdmin", true)
  .include("rsProfile");

const bannedQuery = new Parse.Query(Parse.User)
  .equalTo("tenantBanned", true)
  .notEqualTo("tenantAdmin", true)
  .include("rsProfile");

const adminsQuery = new Parse.Query(Parse.User)
  .equalTo("tenantAdmin", true)
  .include("rsProfile");

export function AdminUsersRoute() {
  let { tab } = useParams();

  tab ??= "unverified";

  return (
    React.createElement(React.Fragment, null
      , React.createElement(AdminUsersList, {
        query: unverifiedQuery,
        context: tab,
        active: tab === "unverified", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
      )
      , React.createElement(AdminUsersList, {
        query: verifiedQuery,
        context: tab,
        active: tab === "verified", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      )
      , React.createElement(AdminUsersList, {
        query: bannedQuery,
        context: tab,
        active: tab === "banned", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      )
      , React.createElement(AdminUsersList, {
        query: adminsQuery,
        context: tab,
        active: tab === "admins", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      )
    )
  );
}
